module.exports = __webpack_public_path__ + "static/media/MentorAndrea.0073de76.jpeg";